import { render, staticRenderFns } from "./TreeCollapse.vue?vue&type=template&id=057f2292&"
import script from "./TreeCollapse.vue?vue&type=script&lang=js&"
export * from "./TreeCollapse.vue?vue&type=script&lang=js&"
import style0 from "./TreeCollapse.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports